// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image[data-v-78c39006]{height:auto;max-width:228px;width:100%}@media screen and (min-width:768px){.image[data-v-78c39006]{max-width:328px}}.page-container[data-v-78c39006]{min-height:calc(100dvh - 100px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
